import { useTranslation } from 'react-i18next';

import type { ExtractionSource, ExtractionSourceRecordType } from '@optiro/types';
import { Anchor, Text } from '@optiro/ui';

import { API_URL } from '@/lib/apiUrl';

import { clock } from './clock';
import { useExtractionSources } from './hooks/useExtractionSources';

export interface SourceLineProps {
  projectId: string | number | null | undefined;
  recordType: ExtractionSourceRecordType;
  recordId: string | number;
}

/** The Kilde of a record as a line: the file it came from (opens it), the udtræk, and for a lydmemo the time. */
export const SourceLine = ({ projectId, recordType, recordId }: SourceLineProps) => {
  const { data } = useExtractionSources(projectId, recordType, [Number(recordId)]);
  const source = data?.[String(recordId)];

  return source ? <SourceText source={source} /> : null;
};

export const SourceText = ({ source }: { source: ExtractionSource }) => {
  const { t } = useTranslation('extraction');
  const time = source.anchor?.time_seconds;

  return (
    <Text size="xs" c="dimmed">
      {t('source.from')}{' '}
      {source.file_deleted || source.file_upload_id == null ? (
        <>
          <Text span size="xs">
            {source.file_name}
          </Text>{' '}
          ({t('source.file_deleted')})
        </>
      ) : (
        <Anchor
          size="xs"
          href={`${API_URL}/api/v1/files/${source.file_upload_id}`}
          target="_blank"
          rel="noreferrer"
        >
          {source.file_name}
        </Anchor>
      )}
      {time != null && ` · ${t('source.at', { time: clock(time) })}`}
    </Text>
  );
};
